import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { useEffect } from 'react'
import Button from '../../shared/button/Btn'
import PageTopTitle from '../../shared/PageTopTitle'
import { useLocation } from 'react-router-dom'
import { useScrollLock } from '../../../hooks/useScrollLock'
import { showModal } from '../../../features/modal/modalSlice'
import { handleActiveSelect } from '../../../features/layout/layoutSlice'
import { setIsKayitLoad, updateKayitliLoad } from '../../../features/kayit/kayitSlice'
import InputSide from '../../loadUpdate/mainSides/inputside/InputSide'
import MapSide from '../../loadUpdate/mainSides/mapSide/MapSide'
import updateReplicator from '../../../helper/load/updateReplicator'
import { setAracData, setPaketlemeData, setPaymentData, setRoute, setRouteDistance, setYukData } from '../../../features/updateLoad/updateLoadSlice'
import { buildRegisteredLoadPayload } from '../../../helper/load/registeredLoadPayload'
import submitLoadPermission from '../../../helper/load/submitLoadPermission'
import { toast } from 'react-toastify'
import { setErrors } from '../../../features/addLoad/addLoadSlice'

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1500px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            height: 650px;
            overflow: auto;
            padding: 40px;

            .top-container{
                width: 100%;
            }
            
            .side-container{
                width: 100%;
                display: flex;
                gap: 40px;
            }
        
        }

        .btn-container{
            width: 100%;
            height: 70px;
            margin: 0 40px;
            gap: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        }
    }
`
const KayitliYukGuncelleModal = () => {
  const dispatch = useDispatch()

  const location = useLocation()
  const { loadItemData } = useSelector(state => state.loadList)

  const {modalLocation } = useSelector(state => state.modal)
  const { lockScroll, unlockScroll } = useScrollLock();
  const {route, aracData, paymentData, yukData, paketlemeData, routeDistance} = useSelector(state => state.updateLoad)
  const {aracTypes = []} = useSelector(state => state.adminSett)
  const {isLoadingUpdateKayitliLoad} = useSelector(state => state.kayit)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        if (isLoadingUpdateKayitliLoad || !loadItemData?.id) return

        if (!submitLoadPermission(route, aracData, paymentData, yukData, paketlemeData, routeDistance)) {
            toast.error("Lütfen gerekli alanları doldurduktan sonra tekrar deneyin.")
            dispatch(setErrors(true))
            return
        }

        const data = buildRegisteredLoadPayload({
            route,
            aracData,
            paymentData,
            yukData,
            paketlemeData,
            routeDistance,
            existingLoad: loadItemData,
            isUpdate: true,
        })

        dispatch(updateKayitliLoad(data))
    }

    

    useEffect(()=>{
        dispatch(setIsKayitLoad(true))
        return () => {
            dispatch(setIsKayitLoad(false))
            dispatch(setErrors(false))
        }
    },[dispatch])

    useEffect(()=> {
        if (!loadItemData?.id) return

        const { paymentDataResolver, aracDataResolver, yukDataResolver, routeResolver, paketlemeDataResolver} = updateReplicator(loadItemData, aracTypes)

        dispatch(setAracData(aracDataResolver))
        dispatch(setYukData(yukDataResolver))
        dispatch(setPaymentData(paymentDataResolver))
        dispatch(setRoute(routeResolver))
        dispatch(setPaketlemeData(paketlemeDataResolver))
        dispatch(setRouteDistance(loadItemData.distance))
    },[aracTypes, dispatch, loadItemData])

  return (
    <ModalContainer onClick={()=> {dispatch(showModal(null)); dispatch(setIsKayitLoad(false))}}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Ön Tanımlı Yük Güncelle"}/>
            <div className="content">
                <div className="top-container"></div>
                <div className="side-container">
                    <InputSide kayitGuncelle />
                    <MapSide kayitGuncelle />
                </div>
            </div>
            <div className="btn-container">
                <Button bgColor="#E85546" color="#fff" width={"220px"} isDisabled={isLoadingUpdateKayitliLoad} handleClick={handleSubmit}>{isLoadingUpdateKayitliLoad ? "Güncelleniyor..." : "Yük Güncelle"}</Button>
                <Button bgColor="#fff" color="#E85546" width={"220px"} handleClick={() => {dispatch(showModal(null)); dispatch(setIsKayitLoad(false))}}>Vazgeç</Button>
            </div>
        </div>
    </ModalContainer>
  )
}

export default KayitliYukGuncelleModal

